/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstanceWithZone } from "./ForcingSubstanceWithZone";
import {
  ForcingSubstanceWithZoneFromJSON,
  ForcingSubstanceWithZoneFromJSONTyped,
  ForcingSubstanceWithZoneToJSON,
  ForcingSubstanceWithZoneToJSONTyped,
} from "./ForcingSubstanceWithZone";
import type { LocalRainUnitEnum } from "./LocalRainUnitEnum";
import {
  LocalRainUnitEnumFromJSON,
  LocalRainUnitEnumFromJSONTyped,
  LocalRainUnitEnumToJSON,
  LocalRainUnitEnumToJSONTyped,
} from "./LocalRainUnitEnum";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface TimeseriesLocalRain
 */
export interface TimeseriesLocalRain {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * Timeseries provided as a nested list. The inner list consists of exactly 2 values: timestamp, value
   */
  values: Array<Array<number>>;
  /**
   *
   */
  interpolate?: boolean;
  /**
   * m/s is only option for now
   *
   * * `m/s` - meter_per_second
   * * `mm/h` - millimeter_per_hour
   * * `mm/min` - millimeter_per_minute
   */
  units?: LocalRainUnitEnum;
  /**
   *
   */
  diameter: number;
  /**
   *
   */
  point: Point;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstanceWithZone>;
}

/**
 * Check if a given object implements the TimeseriesLocalRain interface.
 */
export function instanceOfTimeseriesLocalRain(value: object): value is TimeseriesLocalRain {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("values" in value) || value["values"] === undefined) return false;
  if (!("diameter" in value) || value["diameter"] === undefined) return false;
  if (!("point" in value) || value["point"] === undefined) return false;
  return true;
}

export function TimeseriesLocalRainFromJSON(json: any): TimeseriesLocalRain {
  return TimeseriesLocalRainFromJSONTyped(json, false);
}

export function TimeseriesLocalRainFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesLocalRain {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    values: json["values"],
    interpolate: json["interpolate"] == null ? undefined : json["interpolate"],
    units: json["units"] == null ? undefined : LocalRainUnitEnumFromJSON(json["units"]),
    diameter: json["diameter"],
    point: PointFromJSON(json["point"]),
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceWithZoneFromJSON),
  };
}

export function TimeseriesLocalRainToJSON(json: any): TimeseriesLocalRain {
  return TimeseriesLocalRainToJSONTyped(json, false);
}

export function TimeseriesLocalRainToJSONTyped(
  value?: Omit<TimeseriesLocalRain, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    values: value["values"],
    interpolate: value["interpolate"],
    units: LocalRainUnitEnumToJSON(value["units"]),
    diameter: value["diameter"],
    point: PointToJSON(value["point"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceWithZoneToJSON),
  };
}
